export default __webpack_public_path__ + "static/media/f182.0678956a.png";